
import { UsersRound } from 'lucide-react';
import { IconTitle } from '@/components/ui/icon-title';

interface OccupancyCardProps {
  currentOccupancy: number;
  peopleIn: number;
  peopleOut: number;
  isOnline: boolean;
  // Adding device status information
  deviceStatus: {
    online: number;
    total: number;
  };
}

export function OccupancyCard({
  currentOccupancy,
  peopleIn,
  peopleOut,
  isOnline,
  deviceStatus
}: OccupancyCardProps) {
  return (
    <div className="flex flex-col bg-white rounded-[10px] shadow-card p-2 gap-1.5 border border-light-grey h-[140px]">
      {/* Header */}
      <div className="flex items-center justify-between">
        <IconTitle icon={UsersRound} title="Occupancy" />
        {/* Total People without border */}
        <div className="flex items-baseline gap-1">
          <span className="heading-6 font-semibold text-black">{currentOccupancy.toLocaleString()}</span>
          <span className="paragraph-12 text-dark-grey">persons</span>
        </div>
      </div>

      {/* CCTV Status - Compact Style */}
      <div className="flex items-center justify-between mb-1">
        <span className="paragraph-9 text-dark-grey">CCTV Status</span>
        <div className="flex gap-1">
          {/* Online Status */}
          <div className="w-[65px] px-1.5 py-0.5 rounded-[4px] flex items-center justify-between gap-1 bg-success/20">
            <div className="flex items-center gap-1">
              <div className="w-1 h-1 rounded-full bg-[#14B8B4]" />
              <span className="text-[9px] text-black">Online</span>
            </div>
            <span className="text-[9px] font-semibold text-dark-green">
              {deviceStatus.online}
            </span>
          </div>
          {/* Offline Status */}
          <div className="w-[65px] px-1.5 py-0.5 rounded-[4px] flex items-center justify-between gap-1 bg-gray-200/40">
            <div className="flex items-center gap-1">
              <div className="w-1 h-1 rounded-full bg-[#B4B4B4]" />
              <span className="text-[9px] text-black">Offline</span>
            </div>
            <span className="text-[9px] font-semibold text-dark-grey">
              {deviceStatus.total - deviceStatus.online}
            </span>
          </div>
        </div>
      </div>

      {/* People In/Out */}
      <div className="flex gap-1.5 mt-auto">
        <div className="flex flex-col grow p-1 bg-bg rounded-md border border-light-grey justify-between gap-1">
          <span className="paragraph-11 text-dark">People In</span>
          <div className="flex items-baseline gap-1 text-black">
            <span className="heading-6">{peopleIn.toLocaleString()}</span>
            <span className="paragraph-12">persons</span>
          </div>
        </div>
        <div className="flex flex-col grow p-1 bg-bg rounded-md border border-light-grey justify-between gap-1">
          <span className="paragraph-11 text-dark">People Out</span>
          <div className="flex items-baseline gap-1 text-black">
            <span className="heading-6">{peopleOut.toLocaleString()}</span>
            <span className="paragraph-12">persons</span>
          </div>
        </div>
      </div>
    </div>
  );
}
